import { useSelector } from "react-redux";
import HierarchyTree from "./hierarchyTree";
import CreateTerritory from "./createTerritory";
import { useState } from "react";

const Hierarchy = ({
    isShowNewCreationUI,
    setIsShowNewCreationUI,
    handleSubmit,
    createTerritoryFrom,
    setCreateTerritoryFrom,
    isCreate, setIsCreate,
    handleDeleteTerritory,
    handleUpdate,
    handleRemoveTerritoryManager,
    handleChangeTerritoryManager,
    showTreeNode,
    setShowTreeNode
}) => {
    let territoryList = useSelector((state) => state?.territory)?.territoryList;
    let [selectedTerritoryToEdit, setSelectedTerritoryToEdit] = useState();

    return (
        <>
            {isShowNewCreationUI ?
                <CreateTerritory setIsShowNewCreationUI={setIsShowNewCreationUI} handleSubmit={handleSubmit}
                    createTerritoryFrom={createTerritoryFrom} isCreate={isCreate} selectedTerritoryToEdit={selectedTerritoryToEdit}
                    handleUpdate={handleUpdate} />
                :
                <HierarchyTree territoryList={territoryList} setCreateTerritoryFrom={setCreateTerritoryFrom}
                    setIsShowNewCreationUI={setIsShowNewCreationUI} handleDeleteTerritory={handleDeleteTerritory}
                    setIsCreate={setIsCreate} setSelectedTerritoryToEdit={setSelectedTerritoryToEdit}
                    handleRemoveTerritoryManager={handleRemoveTerritoryManager} handleChangeTerritoryManager={handleChangeTerritoryManager}
                    showTreeNode={showTreeNode} />
            }
        </>
    )
}
export default Hierarchy;